import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ToggleLabel, ToggleInput, ToggleSpan } from './style';
const Toggle = ({ name, className, checked = false, disabled = false, labelSize = '2rem', onChangeValue, onChange, testId, id, }) => {
    const handleChange = (e) => {
        if (disabled)
            return;
        if (onChange) {
            onChange(e);
        }
        else if (onChangeValue) {
            const { checked } = e.target;
            onChangeValue(checked);
        }
    };
    return (_jsxs(ToggleLabel, { labelSize: labelSize, className: className, "data-testid": testId, "data-cy": "toggle-label", children: [_jsx(ToggleInput, { type: "checkbox", "data-cy": "toggle-input", name: name, disabled: disabled, checked: checked, onChange: handleChange, id: id }), _jsx(ToggleSpan, { labelSize: labelSize, "data-cy": "toggle-span", disabled: disabled })] }));
};
export default Toggle;
//# sourceMappingURL=Toggle.js.map